import eldecofairwayreserve from "../../../../public/projects/eldeco/images/eldecofairwayreserve.webp";
import logo from "../../../../public/projects/eldeco/images/banner/logo.png"

export const developersEldeco = {
  name: `Eldeco Properties in Gurugram`,
  properties: [
    {
      name: "Eldeco - Fairway Reserve",
      image: eldecofairwayreserve,
      price: "On Request",
      location: "Sector 80",
      state:"Gurugram",
      projectlocation:"Dwarka Expressway",
      developer:"Eldeco",
      bed: "3 - 4 BHK",
      size: "....",
      url: ``,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};


export const Headers={
  logo:logo,
  data:
    {
      experience:`1975`,
      projects:`100`,
      ongoingprojects:`15`
    },
  about:`Eldeco is a well-established real estate developer in India, known for 
  creating high-quality residential, commercial, and industrial projects. With a focus on timely
   delivery, customer satisfaction, and sustainable construction practices, Eldeco offers premium homes and 
   modern commercial spaces. The company has a strong presence in northern India.`
}